const comments = [
  {
    id: 1,
    name: '追剧少女小樱',
    avatar: '樱',
    time: '2小时前',
    content: '日韩影视网的画质真的绝了！1080P看春日华尔兹太享受了，完全不卡顿。已经推荐给身边所有追剧的朋友了，大家都说好用！',
    likes: 326,
    tag: '春日华尔兹',
  },
  {
    id: 2,
    name: '深夜剧评人',
    avatar: '夜',
    time: '5小时前',
    content: '终于找到一个日剧资源这么全的平台了！暗影追踪第三季刚在日本播出就能同步看到，翻译质量也很棒，追剧体验满分。',
    likes: 218,
    tag: '暗影追踪',
  },
  {
    id: 3,
    name: '韩剧十级学者',
    avatar: '韩',
    time: '8小时前',
    content: '作为一个看了几百部韩剧的老粉，日韩影视网的分类和推荐算法真的很懂我。每次打开的推荐列表都有我想看的，追剧效率高了很多。',
    likes: 195,
    tag: '韩剧推荐',
  },
  {
    id: 4,
    name: '日系治愈控',
    avatar: '日',
    time: '1天前',
    content: '江户物语的特别篇居然这么快就上线了！画质清晰，字幕精准，而且完全不用等缓冲。日韩影视网真的拯救了我的周末追剧时光！',
    likes: 167,
    tag: '江户物语',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            观众热评
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            来自真实观众的评价，看看大家都在追哪些好剧
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <article
              key={comment.id}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 hover:border-primary-200/50 transition-colors duration-200"
            >
              <div className="flex items-start gap-3">
                <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-sm font-bold">
                  {comment.avatar}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{comment.name}</span>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {comment.content}
                  </p>
                  <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                    <span>{comment.time}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-line text-sm text-primary-500"></i>
                      {comment.likes}
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}